import React from 'react';
import PropTypes from 'prop-types';
import MetroIcon from '../../assets/icons/metro-tools.svg';
import styles from './ToolsListView.module.css';
import clsx from 'clsx';
import { useRef } from 'react';
import { LANDING_PAGE_MODULE_PRIVILEGE } from '../../constants/constVariables';
import { useAuthorizationContext } from '../../providers/AuthorizationHandler/AuthorizationHandler';

const ToolsListView = ({ listItems = [], handleSelection }) => {
    const ImageToggleOnMouseOver = ({ primaryImg, secondaryImg }) => {
        const imageRef = useRef(null);

        return (
            <img
                onMouseOver={() => {
                    imageRef.current.src = secondaryImg;
                }}
                onMouseOut={() => {
                    imageRef.current.src = primaryImg;
                }}
                src={primaryImg}
                alt=""
                ref={imageRef}
            />
        )
    }
    const { isAuthenticated, user } = useAuthorizationContext();
    return (
        <>
            <div className={styles.toolListView}>
                <div className={styles.toolListTitleContainer}>
                    <span className={clsx(styles.toolListTitle)}>Tools</span>
                </div>
                {listItems.map((item, index) => (
                    <button
                        type="button"
                        onClick={() => (item.action ? item.action() : handleSelection(item))}
                        className={clsx(styles.toolListItem)}
                        key={index}
                        style={{
                            display: user?.track_your_vehicle_functions?.some(role => LANDING_PAGE_MODULE_PRIVILEGE[role?.toLowerCase()]?.includes(item?.privilege.toLowerCase())) ? 'flex' : 'none'
                        }}
                    >
                        <span>{item.label}</span>
                        {
                            <div className={styles.toolListIcon}>

                                {item.icon}
                            </div>
                        }
                    </button>
                ))}
            </div>
        </>
    )
};


ToolsListView.propTypes = {
    listItems: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            action: PropTypes.func,
        }),
    ),
    handleSelection: PropTypes.func.isRequired,
};

export default ToolsListView;
